import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../url"

export const newFeedbackApi = createApi({
  reducerPath: "newFeedbackApi",
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      // Читаем токен при каждом запросе, чтобы использовать актуальное значение
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        // Убеждаемся, что токен имеет правильный формат (Bearer префикс)
        const token = accessToken.startsWith("Bearer ") 
          ? accessToken 
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        // headers.set('Content-type', 'x-www-form-urlencoded')
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    sendMessage: builder.mutation({
      query: (body) => ({
        url: "/master/send-support-email",
        method: "POST",
        body: body.formData,
      }),
    }),
  }),
})

export const {useSendMessageMutation} = newFeedbackApi
